import { useEffect, useState } from 'react';
import { listarClientes } from '../api';

/**
 * Tela de abertura — o Flow abre sem empresa escolhida.
 *
 * Antes ele selecionava a primeira da lista, o que faz trabalhar no cliente
 * errado por inércia: você abre, vê números, e só depois percebe que é de
 * outra empresa. Agora nada é escolhido por você.
 *
 * Enquanto não há empresa, o que cabe aqui é o panorama da carteira — o que
 * vale olhar antes de escolher uma empresa, não depois.
 */
export default function BemVindo() {
  const [resumo, setResumo] = useState(null);

  useEffect(() => {
    listarClientes()
      .then(r => {
        const itens = (r.items || []).filter(c =>
          c.modulo_contabil || c.modulo_fiscal || c.modulo_relatorios);
        setResumo({
          total:       itens.length,
          contabil:    itens.filter(c => c.modulo_contabil).length,
          fiscal:      itens.filter(c => c.modulo_fiscal).length,
          semRegime:   itens.filter(c => !c.regime_efetivo && !c.regime).length,
          semAbertura: itens.filter(c => !c.data_abertura).length,
          semResp:     itens.filter(c => !c.contato_nome || !c.contato_cpf).length,
        });
      })
      .catch(() => setResumo(null));
  }, []);

  const numero = { fontFamily: 'var(--font-data)', fontSize: 30, fontWeight: 500,
                   lineHeight: 1.1, color: 'var(--text-primary, var(--text))' };
  const rotulo = { fontSize: 11, color: 'var(--text-secondary)', marginTop: 4 };

  const pendencias = resumo ? [
    ['regime tributário', resumo.semRegime],
    ['data de abertura',  resumo.semAbertura],
    ['responsável',       resumo.semResp],
  ].filter(([, n]) => n > 0) : [];

  return (
    <div style={{ maxWidth: 760, margin: '6vh auto 0', padding: '0 8px' }}>
      <div style={{ fontFamily: "'Josefin Sans', 'Outfit', sans-serif", fontWeight: 300,
        fontSize: 30, letterSpacing: '0.3em', textTransform: 'uppercase',
        color: 'var(--gold)' }}>
        Atrio
      </div>
      <div style={{ fontSize: 10.5, letterSpacing: '0.24em', textTransform: 'uppercase',
        color: 'var(--text-secondary)', marginTop: 2 }}>
        Contabilidade
      </div>

      <h1 style={{ fontSize: 26, marginTop: 28, marginBottom: 6 }}>
        Escolha a empresa para começar
      </h1>
      <p className="muted" style={{ fontSize: 13.5, maxWidth: '58ch', marginBottom: 32 }}>
        O seletor de empresa fica no alto da tela. Nada é aberto por padrão —
        assim não se trabalha na empresa errada por inércia.
      </p>

      {resumo && (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
            <div className="card" style={{ padding: 16 }}>
              <div style={numero}>{resumo.total}</div>
              <div style={rotulo}>empresas no Flow</div>
            </div>
            <div className="card" style={{ padding: 16 }}>
              <div style={numero}>{resumo.contabil}</div>
              <div style={rotulo}>com escrituração contábil</div>
            </div>
            <div className="card" style={{ padding: 16 }}>
              <div style={numero}>{resumo.fiscal}</div>
              <div style={rotulo}>com módulo fiscal</div>
            </div>
          </div>

          {pendencias.length > 0 && (
            <p className="small muted" style={{ marginTop: 18 }}>
              Cadastro incompleto na carteira:{' '}
              {pendencias.map(([o, n], i) => (
                <span key={o}>
                  {i > 0 && ' · '}
                  <strong>{n}</strong> sem {o}
                </span>
              ))}
              . Resolve-se em Admin {'›'} Clientes.
            </p>
          )}
        </>
      )}
    </div>
  );
}
